import Header from '@/components/Header';
import Footer from '@/components/Footer';
import PageHero from '@/components/PageHero';
import Section from '@/components/Section';
import { HERO, INTRO, TEAM } from './config';
import styles from './index.module.scss';

export default function About() {
  return (
    <div className={styles.page}>
      <Header />
      <main>
        <PageHero image={HERO.image} alt={HERO.title}>
          <h1 className={styles.heroTitle}>{HERO.title}</h1>
          <p>{HERO.subtitle}</p>
        </PageHero>

        <Section title={INTRO.title}>
          <div className={styles.introRow}>
            <div className={styles.introText}>
              {INTRO.paragraphs.map((p, i) => (
                <p key={i} className={styles.introBody}>
                  {p}
                </p>
              ))}
            </div>
            <div className={styles.introImage}>
              <img src={INTRO.image} alt={INTRO.title} loading="lazy" />
            </div>
          </div>
        </Section>

        <Section title={TEAM.title} background={TEAM.bg}>
          <div className={styles.teamRow}>
            <div className={styles.teamImage}>
              <img src={TEAM.image} alt={TEAM.title} loading="lazy" />
            </div>
            <div className={styles.teamText}>
              {TEAM.paragraphs.map((p, i) => (
                <p key={i} className={styles.teamPara}>
                  {p}
                </p>
              ))}
            </div>
          </div>
        </Section>
      </main>
      <Footer />
    </div>
  );
}
